import React from 'react';
import type {ChartEventViewModel} from "../../../../domain/full-game/models/chart-events/event/chart-event.view-model";
import {CompetitorPlayersStatsModuleShot} from "./competitor-players-stats-module.shot";
import {GameShotChartWidgetFootballShot} from "../../../../widgets/game-shot-chart-widget/components/shot/game-shot-chart.widget.football-shot";
import styles from "../../styles/competitor-players-stats-module.module.scss";
import {COMPETITOR_PLAYER_STATS} from "../../competitor-players-stats-module.consts";
import {observer} from 'mobx-react';
import classNames from "classnames";
import {GAME_SHOT_CHARTS} from "../../../../widgets/game-shot-chart-widget/game-shot-charts.widget.consts";

export const CompetitorPlayersStatsModuleShots = observer(({controller, width, height}) => {
  const {state} = controller;
  const {game: {homeCompetitor, awayCompetitor}, isFootball, selectedPlayer} = state;
  const {shots, selectedShot} = selectedPlayer;
  const classNameCourt = styles.shot_court;
  const sideOffset: Number = width * GAME_SHOT_CHARTS.SHOTS_OFFSET.side / 100;
  const lineOffset: Number = (height * GAME_SHOT_CHARTS.SHOTS_OFFSET.line) / 100;

  const shotProps = {
    width,
    height,
    controller,
    lineOffset,
    sideOffset,
    classNameCourt,
    selectedShot,
    onClick: (shot) => controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.onShotSelected, {shot, isOnShotClick: true})
  }

  return (
    shots.map((shot: ChartEventViewModel) => {
      return isFootball ? <GameShotChartWidgetFootballShot
        shot={shot}
        key={shot.key}
        classNameShot={classNames(styles.shot_mark, {[styles.goal]: shot.isGoalType})}
        color={shot.isHomeCompetitor ? homeCompetitor.color : awayCompetitor.color}
        {...shotProps}
      /> : <CompetitorPlayersStatsModuleShot shot={shot} {...shotProps}/>
    })
  )
})
